// extracted by mini-css-extract-plugin
export default {"container":"TextEllipsis-module--container--O5mkF"};